import type { PlanType } from '@simplywallst/services/types/endpoints/getUacCheck';
import { GrandfatherCoupons } from '@/components/OurPlans/components/Plans/constants';

type CheckAprilPromoParams = {
  loggedIn: boolean;
  couponId?: string;
  planType?: PlanType;
};

export const checkAprilPromo = ({
  loggedIn,
  couponId = '',
  planType = '',
}: CheckAprilPromoParams) => {
  const isGrandfatherCoupon = GrandfatherCoupons.includes(couponId);
  const isPaidUser = ['premium', 'unlimited'].includes(planType);
  if (!loggedIn) {
    return true;
  }

  return !(isGrandfatherCoupon || isPaidUser);
};
